import type { Shadows } from '@mui/material/styles';

/** Cards stay flat. Popovers get one restrained shadow. MUI still wants 25 slots. */
export const elevationShadows: Shadows = [
  'none',
  '0 1px 2px rgba(0,0,0,0.25)',
  '0 1px 2px rgba(0,0,0,0.25)',
  '0 4px 12px rgba(0,0,0,0.4)',
  '0 4px 12px rgba(0,0,0,0.4)',
  '0 4px 12px rgba(0,0,0,0.4)',
  '0 4px 12px rgba(0,0,0,0.4)',
  '0 4px 12px rgba(0,0,0,0.4)',
  '0 4px 12px rgba(0,0,0,0.4)',
  '0 4px 12px rgba(0,0,0,0.4)',
  '0 4px 12px rgba(0,0,0,0.4)',
  '0 4px 12px rgba(0,0,0,0.4)',
  '0 4px 12px rgba(0,0,0,0.4)',
  '0 4px 12px rgba(0,0,0,0.4)',
  '0 4px 12px rgba(0,0,0,0.4)',
  '0 4px 12px rgba(0,0,0,0.4)',
  '0 4px 12px rgba(0,0,0,0.4)',
  '0 4px 12px rgba(0,0,0,0.4)',
  '0 4px 12px rgba(0,0,0,0.4)',
  '0 4px 12px rgba(0,0,0,0.4)',
  '0 4px 12px rgba(0,0,0,0.4)',
  '0 4px 12px rgba(0,0,0,0.4)',
  '0 4px 12px rgba(0,0,0,0.4)',
  '0 4px 12px rgba(0,0,0,0.4)',
  '0 4px 12px rgba(0,0,0,0.4)',
];

export const focusRing = '0 0 0 2px rgba(58, 116, 184, 0.7)';

export const customShadows = {
  xs: 'none',
  sm: '0 1px 2px rgba(0,0,0,0.25)',
  md: '0 4px 12px rgba(0,0,0,0.4)',
  lg: '0 4px 12px rgba(0,0,0,0.4)',
  xl: '0 4px 12px rgba(0,0,0,0.4)',
  focus: focusRing,
} as const;
